import { useListTranscriptItemsForScribingSession } from "@elation/api-client/src/stitch-web";
import { isRecordingActiveStep, useStep } from "@elation/transcribe";
import { useEffect } from "react";
import { TranscriptView } from "./TranscriptView";
import {
  sendTranscriptEvent,
  useTranscriptItems,
  useTranscriptScribingSessionId,
} from "./transcriptActor";

export interface TranscriptProps {
  encounterId: number | null;
}

/** Safety-net polling interval. Active when a scribingSessionId is observed. */
const TRANSCRIPT_POLL_INTERVAL_MS = 3_000;

export const Transcript = ({ encounterId }: TranscriptProps) => {
  const items = useTranscriptItems();
  const scribingSessionId = useTranscriptScribingSessionId();

  // Polling fallback: once we know the session id, refetch the full list so
  // missed SSE events don't leave the transcript stale. The transcriptActor's
  // POLL_APPLIED action drops the response if a newer SSE event has landed.
  const polling = useListTranscriptItemsForScribingSession(
    encounterId ?? 0,
    scribingSessionId ?? "",
    {
      query: {
        enabled: encounterId != null && scribingSessionId != null,
        refetchInterval: TRANSCRIPT_POLL_INTERVAL_MS,
      },
    },
  );

  useEffect(() => {
    const polled = polling.data?.data;
    if (!polled) return;
    sendTranscriptEvent({
      type: "POLL_APPLIED",
      items: polled,
      dataUpdatedAt: polling.dataUpdatedAt,
    });
  }, [polling.data, polling.dataUpdatedAt]);

  const [step] = useStep();
  const isRecording = isRecordingActiveStep(step);

  return <TranscriptView items={items} isRecording={isRecording} />;
};
